import script from "./InAppNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./InAppNotifications.vue?vue&type=script&setup=true&lang=js"

import "./InAppNotifications.vue?vue&type=style&index=0&id=4626c618&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4626c618"]])

export default __exports__